/* Way B store: store behavior shared by every page (the engine's theme/store.js; words in window.STORE_T, offer in window.STORE_OFFER).
   Pages mark their parts with data-* hooks; nothing here depends on the version's layout. */
(function () {
  'use strict';
  var C = window.CATALOG || {};
  var LISTS = window.LISTS;
  // the Shopify theme sets STORE_CFG (asset folder, shop base path, collection url), STORE_T (words in the visitor's language)
  // and SHOP (live price, handle and variant of each product, by product id); the mock has none of them
  var CFG = window.STORE_CFG || {}, TT = window.STORE_T || {}, SHOP = window.SHOP || {};
  var t = function (k, d) { return TT[k] || d; };
  // the offer from the brand's store.json (build_data.py writes window.STORE_OFFER into catalog.js)
  var OF = window.STORE_OFFER || {}, AO = OF.addon || {};
  // the add-on offer before checkout sells the add-on: the catalog item in the "care" category (its Shopify variant goes to checkout)
  var careOf = Object.keys(C).filter(function (h) { return (C[h].k || []).indexOf('care') > -1; })[0];
  var PASTE = { h: 'care-brush-offer', of: careOf, t: t('pasteName', AO.t || ''), p: AO.p, c: AO.c, img: (AO.img || []).slice(0, 1) };
  var WARRANTY = OF.warranty || 0, WARRANTY_H = OF.warrantyHandle || '';
  var TIERS = OF.tiers || [];       // bundle tiers, highest first: [[items, extra % off], …]
  var SHARED = (OF.galleryShared || []).map(function (s) { return 'p/' + s + '.webp'; });   // gallery pictures every product shares
  var ICON = {
    bagplus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 8h13l-.9 11.2a1.5 1.5 0 0 1-1.5 1.3H7.9a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/><path d="M12 11.5v5M9.5 14h5"/></svg>',
    trash: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M4.5 7h15M9.5 7V5h5v2M6.5 7l.8 12.2a1.5 1.5 0 0 0 1.5 1.3h6.4a1.5 1.5 0 0 0 1.5-1.3L17.5 7"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>'
  };
  window.STORE = { LISTS: LISTS, ICON: ICON };

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var num = function (s) { return s ? parseFloat(String(s).replace(/[^0-9.]/g, '')) : 0; };
  var money = function (n) { return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  var A = function (src) { return CFG.asset ? CFG.asset + src.replace(/\//g, '-') : '../assets/' + src; };   // Shopify assets are one flat folder
  var COLL = CFG.shopify ? CFG.coll : 'collection.html';
  function purl(h) {
    if (!CFG.shopify) return 'product.html?h=' + h;
    var sp = C[h] && SHOP[C[h].id]; return sp ? CFG.base + 'products/' + sp.h : COLL;
  }
  // live Shopify prices win over the catalog, so the bag always matches the checkout
  if (CFG.shopify) Object.keys(C).forEach(function (h) {
    var sp = SHOP[C[h].id]; if (!sp) return;
    C[h].p = money(sp.p / 100); C[h].c = sp.c > sp.p ? money(sp.c / 100) : null;
  });
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function store(k, v) { try { if (v === undefined) return JSON.parse(sessionStorage.getItem('st-' + k)); sessionStorage.setItem('st-' + k, JSON.stringify(v)); } catch (e) { return null; } }
  function item(h) { return h === PASTE.h ? PASTE : C[h]; }
  window.STORE.item = item; window.STORE.money = money; window.STORE.purl = purl; window.STORE.t = t; window.STORE.num = num; window.STORE.asset = A; window.STORE.esc = esc;

  /* ---------- sale countdown (evergreen: 3 hours per visit) ---------- */
  var end = store('deadline');
  if (!end || end < Date.now()) { end = Date.now() + (2 * 3600 + 59 * 60 + 58) * 1000; store('deadline', end); }
  function tick() {
    var left = Math.max(0, end - Date.now());
    if (!left) { end = Date.now() + 3 * 3600 * 1000; store('deadline', end); }
    var h = Math.floor(left / 3600000), m = Math.floor(left / 60000) % 60, s = Math.floor(left / 1000) % 60;
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    $$('[data-t="h"]').forEach(function (e) { e.textContent = p(h); });
    $$('[data-t="m"]').forEach(function (e) { e.textContent = p(m); });
    $$('[data-t="s"]').forEach(function (e) { e.textContent = p(s); });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- product cards ---------- */
  function card(h, opts) {
    var p = C[h]; if (!p) return '';
    var second = p.img[1] && p.img[1].indexOf('p/') === 0 && SHARED.indexOf(p.img[1]) < 0 ? p.img[1] : null;
    return '<div class="pc" data-h="' + h + '">' +
      '<div class="pc-media"><a href="' + purl(h) + '" tabindex="-1">' +
      '<img loading="lazy" src="' + A(p.img[0]) + '" alt="' + esc(p.t) + '">' +
      (second ? '<img loading="lazy" class="pc-alt" src="' + A(second) + '" alt="">' : '') + '</a>' +
      (p.c ? '<span class="pc-badge">' + t('save', 'Save') + ' ' + Math.round((1 - num(p.p) / num(p.c)) * 100) + '%</span>' : '') +
      '<button class="pc-add" type="button" data-add="' + h + '" aria-label="' + esc(t('addToCart', 'Add {name} to cart').replace('{name}', p.t)) + '">' + ICON.bagplus + '</button></div>' +
      '<a class="pc-title" href="' + purl(h) + '">' + esc(p.t) + '</a>' +
      '<div class="pc-price"><span class="now">' + p.p + '</span>' + (p.c ? '<s>' + p.c + '</s>' : '') + '</div></div>';
  }
  window.STORE.card = card;
  // collection page: category tiles filter the grid (?f=denim ...) by each product's category tags; no filter = every product
  if (document.body.classList.contains('p-collection')) {
    var f = new URLSearchParams(location.search).get('f') || 'all';
    if (f !== 'all') window.COLLECTION = window.COLLECTION.filter(function (h) { return (C[h].k || []).indexOf(f) > -1; });
    $$('.ccat li').forEach(function (li) { li.classList.toggle('on', li.getAttribute('data-f') === f); });
  }
  $$('[data-cards]').forEach(function (el) {
    var key = el.getAttribute('data-cards');
    var list = key === 'collection' ? window.COLLECTION : LISTS[key];
    el.innerHTML = list.map(function (h) { return card(h); }).join('');
  });

  /* ---------- sliders (arrows + dots) ---------- */
  $$('[data-slider]').forEach(function (wrap) {
    var rail = $('[data-rail]', wrap); if (!rail) return;
    var prev = $('[data-prev]', wrap), next = $('[data-next]', wrap), dots = $('[data-dots]', wrap);
    function step() { var c = rail.children[0]; return c ? c.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || 0) : 300; }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    if (dots) {
      dots.innerHTML = Array.prototype.map.call(rail.children, function (_, i) { return '<button type="button" aria-label="' + t('goToSlide', 'Go to slide') + ' ' + (i + 1) + '"></button>'; }).join('');
      $$('button', dots).forEach(function (b, i) { b.addEventListener('click', function () { rail.scrollTo({ left: rail.children[i].offsetLeft - rail.children[0].offsetLeft, behavior: 'smooth' }); }); });
    }
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
      if (dots) {
        var i = Math.round(rail.scrollLeft / Math.max(1, step())); if (rail.scrollLeft >= max) i = rail.children.length - 1;
        $$('button', dots).forEach(function (b, k) { b.classList.toggle('on', k === i); });
        wrap.dispatchEvent(new CustomEvent('slide', { detail: i }));
      }
    }
    rail.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync); setTimeout(sync, 60);
    // drag to scroll with a mouse
    var down = false, x0 = 0, s0 = 0, moved = false;
    rail.addEventListener('mousedown', function (e) { if (e.button) return; down = true; moved = false; x0 = e.pageX; s0 = rail.scrollLeft; });
    window.addEventListener('mouseup', function () { down = false; rail.classList.remove('drag'); });
    rail.addEventListener('mousemove', function (e) {
      if (!down) return; var d = e.pageX - x0;
      if (!moved && Math.abs(d) > 6) { moved = true; rail.classList.add('drag'); }
      if (moved) rail.scrollLeft = s0 - d;
    });
    rail.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  /* ---------- video reviews: muted preview of the card in view, tap for sound ---------- */
  $$('[data-ugc]').forEach(function (wrap) {
    var cards = $$('.ugc-card', wrap);
    function play(i) {
      cards.forEach(function (c, k) {
        var v = $('video', c); if (!v) return;
        if (k === i) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } else if (!c.classList.contains('on')) v.pause();
      });
    }
    wrap.addEventListener('slide', function (e) { play(e.detail); });
    cards.forEach(function (c) {
      var v = $('video', c), b = $('.tap', c);
      if (!v || !b) return;
      b.addEventListener('click', function () {
        var on = !c.classList.contains('on');
        cards.forEach(function (o) { if (o !== c) { o.classList.remove('on'); var ov = $('video', o); if (ov) ov.muted = true; } });
        c.classList.toggle('on', on); v.muted = !on;
        if (on) { v.currentTime = 0; v.play(); } else v.play();
      });
    });
    play(0);
  });

  /* ---------- header: menu drawer, search ---------- */
  function openLayer(id) { var el = document.getElementById(id); if (!el) return; el.hidden = false; requestAnimationFrame(function () { el.classList.add('open'); }); document.documentElement.classList.add('lock'); }
  function closeLayer(el) { el.classList.remove('open'); document.documentElement.classList.remove('lock'); setTimeout(function () { el.hidden = true; }, 260); }
  window.STORE.open = openLayer;
  $$('[data-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); openLayer(b.getAttribute('data-open')); if (b.getAttribute('data-open') === 'search') setTimeout(function () { var i = $('#search input'); if (i) i.focus(); }, 80); }); });
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', function () { closeLayer(b.closest('.layer')); }); });
  $$('.layer').forEach(function (l) { l.addEventListener('click', function (e) { if (e.target === l) closeLayer(l); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { $$('.layer.open').forEach(closeLayer); moreToggle(false); } });
  // "More" menu: hover opens it on desktop; a tap toggles it on touch screens
  var more = $('.hdr-more');
  function moreToggle(on) { if (!more) return; more.classList.toggle('open', on); more.querySelector('button').setAttribute('aria-expanded', on ? 'true' : 'false'); }
  if (more) {
    moreToggle(false);
    more.querySelector('button').addEventListener('click', function (e) { e.stopPropagation(); moreToggle(!more.classList.contains('open')); });
    document.addEventListener('click', function (e) { if (!more.contains(e.target)) moreToggle(false); });
  }
  var si = $('#search input'), sr = $('#search [data-results]');
  function searchRender(q) {
    q = (q || '').trim().toLowerCase();
    var hits = (q ? window.COLLECTION.filter(function (h) { return C[h].t.toLowerCase().indexOf(q) > -1; }) : LISTS.best.slice(0, 4)).slice(0, 8);
    sr.innerHTML = '<p class="sr-h">' + (q ? t('products', 'Products') : t('popular', 'Popular')) + '</p>' + (hits.length ? hits.map(function (h) {
      var p = C[h]; return '<a class="sr-row" href="' + purl(h) + '"><img src="' + A(p.img[0]) + '" alt=""><span><b>' + esc(p.t) + '</b><em>' + p.p + (p.c ? ' <s>' + p.c + '</s>' : '') + '</em></span></a>';
    }).join('') : '<p class="sr-none">' + t('noMatch', 'Nothing matches “{q}”.').replace('{q}', esc(q)) + '</p>') + '<a class="sr-all" href="' + COLL + '">' + t('viewAll', 'View all') + '</a>';
  }
  if (si) { si.addEventListener('input', function () { searchRender(si.value); }); searchRender(''); }

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ut-v]'); if (!sel) return;
    var ul = upLine(sel.closest('[data-ut]').getAttribute('data-ut')); if (ul) { ul.v = sel.value; save(); render(); }
  });

  /* ---------- cart ---------- */
  var cart = store('cart') || { lines: [], warranty: false };
  cart.lines = cart.lines.filter(function (l) { return item(l.h); });   // a bag saved before a piece was renamed or removed
  function save() { store('cart', cart); }
  function count() { return cart.lines.reduce(function (n, l) { return n + l.q; }, 0); }
  function bundled(l) { return l.h !== PASTE.h; }   // every product counts toward the bundle, checkout-upsell ones too (team, 2 Nov); the add-on does not
  function pieces() { return cart.lines.reduce(function (n, l) { return n + (bundled(l) ? l.q : 0); }, 0); }
  function tier() { var n = pieces(); for (var i = 0; i < TIERS.length; i++) if (n >= TIERS[i][0]) return TIERS[i][1]; return 0; }
  function unit(l) { return l.cp != null ? l.cp : num(item(l.h).p); }   // a checkout-upsell line keeps its own price
  function add(h, q, variant) {
    var p = item(h); if (!p) return;
    var v = variant || (p.v ? p.v[1][0] : '');
    var l = cart.lines.filter(function (x) { return x.h === h && (x.v || '') === v; })[0];   // one line per product and colour
    if (l) l.q += q || 1; else cart.lines.push({ h: h, q: q || 1, v: v });
    save(); render();
  }
  window.STORE.add = add;
  /* ---------- upsell switches: one row = photo, name, price, struck price, Save %, colour, on/off ---------- */
  function upLine(h) { return cart.lines.filter(function (x) { return x.h === h && x.u; })[0]; }
  function upRow(h) {
    var c = C[h], l = upLine(h), on = !!l, v = l ? l.v : c.v[1][0];
    var pct = c.c ? Math.round((1 - num(c.p) / num(c.c)) * 100) : 0;
    return '<div class="upr' + (on ? ' on' : '') + '" data-ut="' + h + '"><a class="upr-img" href="' + purl(h) + '" tabindex="-1"><img src="' + A(c.img[0]) + '" alt="" loading="lazy"></a>' +
      '<div class="upr-info"><a class="upr-t" href="' + purl(h) + '">' + esc(c.t) + '</a>' +
      '<div class="upr-pr"><b>' + c.p + '</b>' + (c.c ? '<s>' + c.c + '</s>' : '') + (pct ? '<em>' + t('save', 'Save') + ' ' + pct + '%</em>' : '') + '</div>' +
      '<label class="upr-sel"><span class="vh">' + t('colour', 'Colour') + '</span><select data-ut-v>' + c.v[1].map(function (o) { return '<option' + (o === v ? ' selected' : '') + '>' + esc(o) + '</option>'; }).join('') + '</select></label></div>' +
      '<button type="button" class="upr-sw" role="switch" aria-checked="' + on + '" aria-label="' + esc(t('addToOrder', 'Add {name} to your order').replace('{name}', c.t)) + '"><i></i></button></div>';
  }
  function upPool(n, skip) {   // bestsellers first, never what is already in the bag on its own
    var bagged = cart.lines.filter(function (l) { return !l.u; }).map(function (l) { return l.h; });
    return LISTS.best.concat(LISTS.upsell).filter(function (h, i, a) { return a.indexOf(h) === i && h !== skip && C[h] && C[h].v && bagged.indexOf(h) < 0; }).slice(0, n);
  }
  function render() {
    $$('[data-toggle-list]').forEach(function (el) { el.innerHTML = upPool(3, el.getAttribute('data-exclude')).map(upRow).join(''); });
    $$('[data-count]').forEach(function (e) { var n = count(); e.textContent = n; e.hidden = !n; });
    var d = $('#cart'); if (!d) return;
    $('[data-cart-n]', d).textContent = count();
    var lines = $('[data-lines]', d), empty = !cart.lines.length;
    d.classList.toggle('is-empty', empty);
    lines.innerHTML = cart.lines.map(function (l, i) {
      var p = item(l.h);
      return '<div class="cl"><img src="' + A(p.img[0]) + '" alt=""><div class="cl-info"><a href="' + (l.h === PASTE.h ? purl(PASTE.of) : purl(l.h)) + '">' + esc(p.t) + '</a>' + (l.v ? '<small>' + esc(l.v) + '</small>' : '') +
        '<div class="cl-row"><button class="cl-del" type="button" data-del="' + i + '" aria-label="' + t('remove', 'Remove') + '">' + ICON.trash + '</button><div class="qty"><button type="button" data-q="' + i + '" data-d="-1" aria-label="' + t('decrease', 'Decrease') + '">−</button><span>' + l.q + '</span><button type="button" data-q="' + i + '" data-d="1" aria-label="' + t('increase', 'Increase') + '">+</button></div></div></div>' +
        '<div class="cl-price">' + (p.c ? '<s>' + money(num(p.c) * l.q) + '</s>' : '') + '<b>' + money(unit(l) * l.q) + '</b>' +
        (p.c ? '<small class="cl-save">(' + t('youSave', 'You save') + ' ' + money((num(p.c) - unit(l)) * l.q) + ')</small>' : '') + '</div></div>';
    }).join('');
    // bundle progress: 15 / 25 %
    var n = pieces(), pct = tier(), msg = $('[data-tier-msg]', d), bar = $('[data-tier-bar]', d);
    var nextT = TIERS.slice().reverse().filter(function (x) { return n < x[0]; })[0] || null;   // the next tier up
    msg.innerHTML = nextT ? t(nextT[0] - n > 1 ? 'tierMoreN' : 'tierMore1', 'Add {n} more item' + (nextT[0] - n > 1 ? 's' : '') + ' and save an extra <b>{p}%</b> on everything').replace('{n}', nextT[0] - n).replace('{p}', nextT[1])
      : t('tierDone', 'Nice! <b>{p}% off</b> is now on your whole order').replace('{p}', pct);
    // the bar fills to the last tier reached (the milestones sit at equal steps, the last at 100%); before the first, part way
    var up = TIERS.slice().reverse(), at = up.filter(function (x) { return n >= x[0]; }).length;
    bar.style.width = (at ? 100 * at / up.length : up.length ? 100 / up.length * n / up[0][0] : 0) + '%';
    $$('[data-tier]', d).forEach(function (m) { m.classList.toggle('on', n >= +m.getAttribute('data-tier')); });
    // totals
    var sub = cart.lines.reduce(function (s, l) { return s + unit(l) * l.q; }, 0);
    var cmp = cart.lines.reduce(function (s, l) { var p = item(l.h); return s + num(p.c || p.p) * l.q; }, 0);
    var tierable = cart.lines.reduce(function (s, l) { return s + (bundled(l) ? unit(l) * l.q : 0); }, 0);
    var off = Math.round(tierable * pct) / 100, w = cart.warranty && !empty ? WARRANTY : 0, total = sub - off + w;
    $('[data-savings]', d).textContent = '-' + money(cmp - sub + off);
    $('[data-total]', d).textContent = money(total);
    $('[data-checkout-total]', d).textContent = money(total);
    var dl = $('[data-discount-line]', d); dl.hidden = !off; $('[data-discount]', d).textContent = '-' + money(off); $('[data-discount-pct]', d).textContent = pct;
    $('[data-warranty]', d).checked = !!cart.warranty;
    // "Recommended for you": four products with an on/off switch each
    var cu = $('[data-cart-ups]', d); if (cu) cu.innerHTML = upPool(4).map(upRow).join('');
  }
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('.upr-sw');
    if (sw) {   // switch on: the product goes into the bag in the picked colour; switch off: it comes back out
      var row = sw.closest('[data-ut]'), uh = row.getAttribute('data-ut'), ul = upLine(uh);
      if (ul) cart.lines.splice(cart.lines.indexOf(ul), 1); else cart.lines.push({ h: uh, q: 1, v: $('[data-ut-v]', row).value, u: 1 });
      save(); render(); return;
    }
    var a = e.target.closest('[data-add]');
    if (a) { e.preventDefault(); add(a.getAttribute('data-add'), 1); if (!a.hasAttribute('data-stay')) openLayer('cart'); return; }
    var del = e.target.closest('[data-del]');
    if (del) { cart.lines.splice(+del.getAttribute('data-del'), 1); save(); render(); return; }
    var q = e.target.closest('[data-q]');
    if (q) { var l = cart.lines[+q.getAttribute('data-q')]; l.q += +q.getAttribute('data-d'); if (l.q < 1) cart.lines.splice(+q.getAttribute('data-q'), 1); save(); render(); return; }
    var co = e.target.closest('[data-checkout]');
    if (co) checkout(co);
  });
  // checkout: on the mock a note; on Shopify the bag goes into the Shopify cart and on to Shopify's own checkout
  function checkout(btn) {
    var note = $('[data-co-note]');
    if (!CFG.shopify) { location.href = 'checkout.html'; return; }   // the mock's checkout page (Shopify's own checkout in the live store)
    var items = [];
    // each line goes to Shopify as the variant of its colour; the care plan is its own product (store.json offer.care_plan)
    cart.lines.forEach(function (l) { var p = C[l.h === PASTE.h ? PASTE.of : l.h], sp = p && SHOP[p.id]; if (sp) items.push({ id: (sp.vs && sp.vs[l.v]) || sp.v, quantity: l.q }); });
    if (cart.warranty && SHOP[WARRANTY_H]) items.push({ id: SHOP[WARRANTY_H].v, quantity: 1 });
    if (!items.length) return;
    var base = CFG.base || '/';   // the shop's base path, /es/ in Spanish
    var post = function (url, body) {
      return fetch(base + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body || {}) })
        .then(function (r) { if (!r.ok) { var e = new Error('cart ' + r.status); e.status = r.status; throw e; } return r.json(); });
    };
    btn.disabled = true;
    post('cart/clear.js').then(function () { return post('cart/add.js', { items: items }); })
      .then(function () { location.href = '/checkout' + (CFG.locale && CFG.locale !== 'en' ? '?locale=' + CFG.locale : ''); })
      .catch(function (err) {
        btn.disabled = false;
        // never show Shopify's own wording (it names the product as Shopify has it): a sold-out piece, or try again
        if (note) { note.textContent = err.status === 422 ? t('coSoldOut', 'One of these items has just sold out. Please remove it from your bag and try again.')
          : t('coFail', 'Checkout could not start. Please try again in a moment.'); note.hidden = false; }
      });
  }
  var wt = $('#cart [data-warranty]'); if (wt) wt.addEventListener('change', function () { cart.warranty = wt.checked; save(); render(); });
  render();

  /* ---------- welcome discount popup ---------- */
  var pop = $('#mystery');
  // the welcome popup never lands on top of the bag, menu, search or add-on offer: it waits until they are closed
  function popWhenFree() {
    if (store('mystery-seen')) return;
    if ($$('.layer').some(function (l) { return !l.hidden; })) { setTimeout(popWhenFree, 1500); return; }
    openLayer('mystery'); store('mystery-seen', 1);
  }
  if (pop && !store('mystery-seen')) setTimeout(popWhenFree, 2600);
  if (pop) {
    $$('[data-why]', pop).forEach(function (b) { b.addEventListener('click', function () { pop.setAttribute('data-step', '2'); var i = $('input', pop); if (i) i.focus(); }); });
    var f = $('form', pop); if (f) f.addEventListener('submit', function (e) { e.preventDefault(); pop.setAttribute('data-step', '3'); });
  }

  /* ---------- accordions: one open at a time inside a group ---------- */
  $$('[data-acc-group]').forEach(function (g) {
    $$('details', g).forEach(function (d) { d.addEventListener('toggle', function () { if (d.open) $$('details', g).forEach(function (o) { if (o !== d) o.open = false; }); }); });
  });
})();
